"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FPointsOfSaleService = void 0;
const __1 = require("../../..");
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
class FPointsOfSaleService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    getPointsOfSaleWithMenu(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const pointsOfSaleWithMenuMapper = new mappers_1.PointsOfSaleWithMenuMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_POINTS_OF_SALE_WITH_MENU,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(pointsOfSaleWithMenuMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PointsOfSaleServiceErrors.GetPointsOfSaleWithMenuRequestError("GET_POINTS_OF_SALE_WITH_MENU_REQUEST_FAILED", error));
            }
        });
    }
    getPos(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const posMapper = new mappers_1.PosMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_POS,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(posMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PointsOfSaleServiceErrors.GetPosRequestError("GET_POS_REQUEST_FAILED", error));
            }
        });
    }
    getOnePos(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const onePosMapper = new mappers_1.OnePosMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_ONE_POS,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(onePosMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PointsOfSaleServiceErrors.GetOnePosRequestError("GET_ONE_POS_REQUEST_FAILED", error));
            }
        });
    }
    getPointsOfSale(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const pointsOfSaleWithMenuMapper = new mappers_1.PointsOfSaleWithMenuMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_POINTS_OF_SALE,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(pointsOfSaleWithMenuMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PointsOfSaleServiceErrors.GetPointsOfSaleRequestError("GET_POINTS_OF_SALE_REQUEST_FAILED", error));
            }
        });
    }
    getPosWithOffers(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const posWithOffershMenuMapper = new mappers_1.PosWithOffersMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_POS_WITH_OFFERS,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve(posWithOffershMenuMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.PointsOfSaleServiceErrors.GetPointsOfSaleRequestError("GET_POS_WITH_OFFERS_REQUEST_FAILED", error));
            }
        });
    }
}
exports.FPointsOfSaleService = FPointsOfSaleService;
